import styled, { css, FlattenSimpleInterpolation } from "styled-components";
import { FC } from "react";

import { Search, SearchArgs } from "../../../Search/Search";

export enum SearchOptionTestIds {
  Component = "search-option",
}

type ContainerProps = {
  $isFirst?: boolean;
  $isLast?: boolean;
  $disabled?: boolean;
};

const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: flex-start;
  padding: 8px;
  ${({ $isFirst }): FlattenSimpleInterpolation =>
    $isFirst
      ? css`
          border-top-left-radius: var(--size-border-radius-small);
          border-top-right-radius: var(--size-border-radius-small);
        `
      : css``}
  ${({ $isLast }): FlattenSimpleInterpolation =>
    $isLast
      ? css`
          border-bottom-left-radius: var(--size-border-radius-small);
          border-bottom-right-radius: var(--size-border-radius-small);
        `
      : css``}
`;

type Props = {
  id?: string;
  className?: string;
  testId?: string;
  onSearch: ({ searchText }: SearchArgs) => void;
  placeholder?: string;
  isFirst?: boolean;
  isLast?: boolean;
  disabled?: boolean;
};

export const SearchOption: FC<Props> = ({
  id,
  className,
  testId,
  onSearch,
  placeholder = "Search...",
  isFirst,
  isLast,
  disabled,
  children: _,
  ...props
}) => (
  <Container
    id={id}
    className={className}
    data-testid={testId ?? SearchOptionTestIds.Component}
    $isFirst={isFirst}
    $isLast={isLast}
    $disabled={disabled}
  >
    <Search
      {...props}
      onSearch={onSearch}
      placeholder={placeholder}
      disabled={disabled}
    />
  </Container>
);
